/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：88
 */

module.exports = {
  formGroup: "StyleForm_formGroup__2N4hZ",
  formItemWrapper: "StyleForm_formItemWrapper__xbhBj",
  main: "StyleForm_main__2iLc_",
  label: "StyleForm_label__126ZA",
  nowrap: "StyleForm_nowrap__1wt_q",
  justifyInputContent: "StyleForm_justifyInputContent__3qiCe",
  justifyContentStart: "StyleForm_justifyContentStart__3vc0O",
  radioWrapper: "StyleForm_radioWrapper__eSgf_",
  colorBlock: "StyleForm_colorBlock__1_XB4",
  slash: "StyleForm_slash__2BVFd",
  sizeInputBox: "StyleForm_sizeInputBox__1PA8q",
  sizeInputNumberBox: "StyleForm_sizeInputNumberBox__20Mle",
  typeSelector: "StyleForm_typeSelector__1scQB",
  changeSizeFormItemWrapper: "StyleForm_changeSizeFormItemWrapper__2L0wi",
  sizeRadioBox: "StyleForm_sizeRadioBox__1UEbV",
  formWidgetTitle: "StyleForm_formWidgetTitle__3wjQY",
  formWidgetTitleWithDisableOrVisible: "StyleForm_formWidgetTitleWithDisableOrVisible__3pbio",
  btnIcon: "StyleForm_btnIcon__3l2kv",
  "coco-iconfont": "StyleForm_coco-iconfont__Nd2uv",
  formInputNumberRow: "StyleForm_formInputNumberRow__104HC",
  formTitle: "StyleForm_formTitle__2raW7",
  textInput: "StyleForm_textInput__1Ycf1",
  space: "StyleForm_space__3VDQb",
  optionSwitch: "StyleForm_optionSwitch__JZpRQ",
  option: "StyleForm_option__xEB5k",
  activeOption: "StyleForm_activeOption__19u0Z",
  dialog: "StyleForm_dialog__3Mjk4",
  dialogContent: "StyleForm_dialogContent__33m-5",
  titleWrapper: "StyleForm_titleWrapper__3Pyjb",
  title: "StyleForm_title__3sAaC",
  textWrapper: "StyleForm_textWrapper__2iTBJ",
  line: "StyleForm_line__34kHe",
  firstLine: "StyleForm_firstLine__pu9IW",
  secondLine: "StyleForm_secondLine__3BYTa",
  buttonWrapper: "StyleForm_buttonWrapper__1fPTS",
  button: "StyleForm_button__32T7O",
  secondary: "StyleForm_secondary__cGSk2",
  primary: "StyleForm_primary__1UMIa",
  textButtonWrapper: "StyleForm_textButtonWrapper__3ZcV2",
  fontFamilyWrapper: "StyleForm_fontFamilyWrapper__2dFRJ",
  image: "StyleForm_image__OKNXU",
  downloadIcon: "StyleForm_downloadIcon__5-Xy9",
  iconBox: "StyleForm_iconBox__3TYvG",
  selectedIcon: "StyleForm_selectedIcon__2QPjw",
  disabled: "StyleForm_disabled__bum6S",
  selected: "StyleForm_selected__1RiuQ"
}
